import UserMatchingService from '../../../../../utils/UserMatchingService';
import ParamTypeMixin from './ParamTypeMixin';
import UserMatchingFallbackModal from '../../UserMatchingFallbackModal';
import IsRequiredMixin from './ParamPropertiesMixins/IsRequiredMixin';
import ExternalSourceMixin from './ExternalSourceMixin';
import { mapActions, mapGetters } from 'vuex';
import { rootNode } from '@/store/modules/selectedWorkflow/getters';
import { isNullOrUndefined } from '../../../../../utils/helpers';
import UserMatchingMixinService from './user-matching-mixin-service';
import { setIsDialogActive } from '@/store/modules/dialogs/actions';

/**
 * This mixin adds user matching functionality to param type
 *
 * extending ParamTypeMixin, ExternalSourceMixin
 */

export default {
	mixins: [ParamTypeMixin, IsRequiredMixin],
	components: { UserMatchingFallbackModal },
	computed: {
		...mapGetters([rootNode.fullPath]),
		paramHasUserMatchingOption() {
			return this.param.user_matching_optional;
		},
		isUserMatching() {
			return UserMatchingService.isValueOfUserMatching(this.localValue);
		},
		userMatchingFallback() {
			if (!this.node || !this.node.user_matching_fallbacks) {
				return undefined;
			}
			const found = this.node.user_matching_fallbacks.find((x) => x.param_key === this.param.key);
			if (found) {
				return {
					type: found.fallback_type,
					details: found.fallback_details,
				};
			}
			return undefined;
		},
		originalItems() {
			return ExternalSourceMixin.computed.allItems.call(this);
		},
		// extending ExternalSourceMixin allItems
		allItems() {
			const items = [];
			if (this.paramHasUserMatchingOption) {
				items.push(UserMatchingService.buildUserMatchingOption(this[rootNode.fullPath], this.node.uuid, this.param.key));
			}
			const externalItems = ExternalSourceMixin.computed.allItems.call(this) || [];
			return [...items, ...externalItems];
		},
		userMatchingFallbackModalProps() {
			return {
				showDialog: this.$data._userMatchingDialog,
				isRequired: this.isRequired,
				appInfo: this.service,
				paramName: this.param.name,
				actionName: this.action?.title,
				chooseFromItems: this.originalItems,
				fallbackInit: this.userMatchingFallback,
			};
		},
		userMatchingFallbackModalListeners() {
			return {
				'update:showDialog': (val) => {
					this.$data._userMatchingDialog = val;
				},
				'update-params-fallback': UserMatchingMixinService.updateFallback.bind(this),
			};
		},
	},
	methods: {
		...mapActions([setIsDialogActive.fullPath]),
		openUserMatchingDialog() {
			this.$data._userMatchingDialog = true;
		},
		// extending ExternalSourceMixins method
		updateExternalLocalValue(payload) {
			if (payload.type && payload.type === UserMatchingService.USER_MATCHING_TYPE) {
				this.$data._userMatchingDialog = true;
				this.$data._paramFallback = !isNullOrUndefined(this.userMatchingFallback)
					? this.userMatchingFallback
					: UserMatchingService.initialFallback(this.isRequired);
				UserMatchingMixinService.updateFallback.call(this, this.$data._paramFallback);
			}
			ExternalSourceMixin.methods.updateExternalLocalValue.call(this, payload);
		},
	},
	mounted() {
		this.$data._paramFallback = this.userMatchingFallback;
		UserMatchingMixinService.addUserMatchingFieldRules.call(this);
	},
	data() {
		return { _userMatchingDialog: false, _paramFallback: undefined };
	},
	watch: {
		'$data._userMatchingDialog'(newV) {
			// sync isDialogActive state if we open UserMatchingFallbackModal
			// TODO - use UserMatchingFallbackModal with AppDialogManager
			this[setIsDialogActive.fullPath]({ value: newV });
		},
	},
};
